export function HelpPage() {
  return (
    <>
      <h3>Help</h3>
      <h5 className="mt-2">How-To Welding Questions</h5>
      <ul className="list-styled ps-4 mt-2">
        <li>
          <a href="mailto:weldingsme@williams.com">weldingsme@williams.com</a>
        </li>
        <li>Jon Hembree: 918-645-1591</li>
        <li>Kirby Kunka: 281-703-8134</li>
        <li>Cade Leimer: 918-232-7372</li>
      </ul>
      <h5 className="mt-4">Technical Issues and Software How-To</h5>
      <ul className="list-styled ps-4 mt-2">
        <li>
          <a href="mailto:support@twisoftware.com">support@twisoftware.com</a>
        </li>
      </ul>
      <h5 className="mt-4">Access and Login Support</h5>
      <ul className="list-styled ps-4 mt-2">
        <li>
          <a href="mailto:helpcenter@williams.com">helpcenter@williams.com</a>
        </li>
        <li>1-800-524-2336</li>
      </ul>
    </>
  );
}
